import { BadgeRequestedSide } from './badgeAttachments'
import { DEFAULT_CONNECTION_CREATION, normalizeConnectionCreationDefaults } from './connectionCreationDefaults.js'
import { DEFAULT_CONNECTION_DATA, canonicalConnectionData } from './connectionData.js'
export { DEFAULT_CONNECTION_DATA, canonicalConnectionData } from './connectionData.js'

interface ConnectionCreationDefaults {
    line_width: number
    corner_radius: number
    animation_enabled: boolean
    bullet_size: number
    bullet_count: number
}

export interface ConnectionConfig {
    id: string
    from: string
    to: string
    from_side: BadgeRequestedSide
    to_side: BadgeRequestedSide
    corner_radius: number
    line_width: number
    line_color: string
    min: number
    max: number
    value: number
    value_source: 'own' | 'from' | 'to'
    animation_enabled: boolean
    bullet_color: string
    bullet_size: number
    bullet_count: number
}

export function assignConnectionReferences(
    node: { from?: unknown; to?: unknown },
    config: Pick<ConnectionConfig, 'from' | 'to'>,
): void {
    // Konva.Node.prototype.to is its tween helper, so generic schema setup
    // deliberately leaves it untouched. A connection owns these two fields.
    node.from = String(config.from ?? '')
    node.to = String(config.to ?? '')
}

export function createConnectionConfig(
    id: string,
    from: string,
    to: string,
    fromSide: BadgeRequestedSide,
    lineColor = '#ffffffff',
    defaults: ConnectionCreationDefaults = DEFAULT_CONNECTION_CREATION,
): ConnectionConfig | null {
    if (!id || !from || !to || from === to) return null
    const creationDefaults = normalizeConnectionCreationDefaults(defaults)
    return {
        id, from, to, from_side: fromSide, to_side: 'auto',
        corner_radius: creationDefaults.corner_radius,
        line_width: creationDefaults.line_width,
        line_color: lineColor,
        ...DEFAULT_CONNECTION_DATA,
        animation_enabled: creationDefaults.animation_enabled,
        bullet_color: lineColor,
        bullet_size: creationDefaults.bullet_size,
        bullet_count: creationDefaults.bullet_count,
    }
}

export function normalizeLegacyConnectionConfig<T extends Record<string, any>>(config: T): T {
    if (config?.obj !== 'connection') return config
    if (config.min === undefined && config.min_value !== undefined) config.min = config.min_value
    if (config.max === undefined && config.max_value !== undefined) config.max = config.max_value
    Object.assign(config, canonicalConnectionData(config))
    delete config.min_value
    delete config.max_value
    delete config.bullet_spacing
    return config
}
